export const OPEN_HOUSE_ENABLED = 'sl_open_house';
export const HERO_AD_PLACEHOLDER = 'hero_ad_placeholder';



// WEBPACK FOOTER //
// ./src/common/treatments.js